/**
 * Matches Rails' `errors.to_hash` format: { field: ["msg1", "msg2"] }
 */
export type RailsErrors = Record<string, string[]>;

/**
 * Extracts all error messages from a Rails errors hash into a flat array.
 *
 * @example
 * const errors = { password: ["is too short"], email: ["is invalid"] };
 * extractErrorMessages(errors);
 * // => ["Password is too short", "Email is invalid"]
 */
export const extractErrorMessages = (errors: RailsErrors): string[] =>
  Object.entries(errors).flatMap(([field, messages]) => messages.map((msg) => `${humanizeField(field)} ${msg}`));

/**
 * Gets error messages for a specific field.
 */
export const getFieldErrors = (errors: RailsErrors, field: string): string[] => errors[field] ?? [];

/**
 * Checks if there are any errors.
 */
export const hasErrors = (errors: RailsErrors): boolean => Object.keys(errors).length > 0;

const humanizeField = (field: string): string =>
  field.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
